import createSubflowsFromDefns from 'integration/quoteandbind/config/_createSubflowsFromDefns';
import flowBegining from './_flowBegining';
import wireLOBSection from 'integration/quoteandbind/config/_wireLOBSection';
import { flowTransition } from 'integration/quoteandbind/config/CompositeFlowConfig';

export default ['AvailabilityService', 'qnb.LoadSaveService', '$q', 'TranslateService', 'ViewModelService', 'qnb.ViewModelCtx', 'gateway.ActionMessageUtil', 'EventHub', 'QuoteJumpToStepService',
    function (AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, ActionMessageUtil, EventHub, QuoteJumpToStepService) {

        function branchOnProductCode(subFlows, flowPropertyKey) {
            // given submission, it return a function that transitions to the appropriate subflow
            return ({ value: submission }) => flowTransition(subFlows, submission.baseData.productCode, flowPropertyKey);
        }

        return function (step, junction, flow) {

            const subFlows = createSubflowsFromDefns(flow, AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, ActionMessageUtil, EventHub, QuoteJumpToStepService);
            // create complete flow by wiring up sub flows
            flowBegining(subFlows, branchOnProductCode, TranslateService, LoadSaveService, ViewModelService, ViewModelCtx)(step, junction);
            wireLOBSection(subFlows, branchOnProductCode, TranslateService)(step, junction, flow);
        };
    }
];
